"use strict"; // / <reference path="../../types/react-select.d.ts"/>

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearAll = exports.selectAll = exports.normalizeOptions = exports.convertOptionsToValue = exports.convertProps = exports.arrowRenderer = void 0;

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var react_select_1 = __importDefault(require("react-select"));

var defaultMenuRenderer_1 = __importDefault(require("react-select/lib/utils/defaultMenuRenderer"));

var drop_down_small_svg_1 = __importDefault(require("svgson-loader!@paradigm/icons/src/mailru/navigation/drop_down_small.svg"));

var baseProps_1 = __importStar(require("../assets/baseProps"));

var handleEvent_1 = require("../assets/handleEvent");

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

var modsClassName_1 = require("../assets/modsClassName");

var inputable_1 = require("../decorators/inputable");

var withDefaultValue_1 = require("../decorators/withDefaultValue");

var withResponsive_1 = require("../decorators/withResponsive");

var withStyles_1 = require("../decorators/withStyles");

var Icon_1 = __importDefault(require("../Icon/Icon"));

var Text_1 = __importDefault(require("../Text/Text"));

var List_1 = __importDefault(require("./markup/List"));

var Option_1 = __importDefault(require("./Option"));

var ReactSelect_styles_1 = __importDefault(require("./ReactSelect.styles"));

var Select =
/** @class */
function (_super) {
  __extends(Select, _super);

  function Select() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.valueRenderer = function (_a) {
      var label = _a.label,
          shortLabel = _a.shortLabel,
          option = __rest(_a, ["label", "shortLabel"]);

      var _b = _this.props,
          value = _b.value,
          multi = _b.multi,
          selectAllPlaceholder = _b.selectAllPlaceholder,
          secondary = _b.secondary,
          testId = _b.testId;
      var showSelectAllPlaceholder = _this.showSelectAllPlaceholder;
      var index = value.indexOf(option.value);
      var isFirst = index === 0;
      var mode = secondary ? 'small' : 'control';
      var dataTestId = testId && testId + "-value";

      if (showSelectAllPlaceholder) {
        return isFirst ? react_1.default.createElement(Text_1.default, {
          mode: mode,
          testId: dataTestId
        }, selectAllPlaceholder) : null;
      }

      return react_1.default.createElement(Text_1.default, {
        mode: mode,
        testId: dataTestId
      }, shortLabel || label, multi && index < value.length - 1 ? ',' : null);
    };

    _this.menuRenderer = function (options) {
      var _a = _this,
          props = _a.props,
          isAllSelected = _a.isAllSelected;
      var selectAllAction = props.selectAllAction,
          selectAllActionText = props.selectAllActionText,
          clearable = props.clearable,
          clearAllText = props.clearAllText,
          multi = props.multi,
          menuMaxHeight = props.menuMaxHeight,
          menuMinHeight = props.menuMinHeight,
          menuForceBottom = props.menuForceBottom,
          menuForceTop = props.menuForceTop,
          right = props.right,
          menuContainer = props.menuContainer,
          menuContainerTestId = props.menuContainerTestId,
          menuMinWidth = props.menuMinWidth,
          menuMaxWidth = props.menuMaxWidth,
          small = props.small;
      var pinnedOptions = [];
      var regularOptions = [];
      options.options.forEach(function (option) {
        if (option.pin) {
          pinnedOptions.push(option);
        } else {
          regularOptions.push(option);
        }
      });
      var focused = {
        optionData: options.focusedOption,
        focusedRef: null
      };
      var pinnedItems = defaultMenuRenderer_1.default(__assign(__assign({}, options), {
        options: pinnedOptions,
        optionComponent: Option_1.default
      }));
      var itemsJsx = defaultMenuRenderer_1.default(__assign(__assign({}, options), {
        options: regularOptions,
        optionComponent: Option_1.default,
        onOptionRef: function onOptionRef(ref, isFocused) {
          if (isFocused) {
            focused.focusedRef = ref;
          }
        }
      }));
      var setValue = options.setValue || _this.setValue;

      var boundSelectAll = function boundSelectAll() {
        return selectAll({
          props: props,
          setValue: setValue,
          options: options
        });
      };

      var boundClearAll = function boundClearAll() {
        return clearAll({
          props: props,
          setValue: setValue,
          options: options
        });
      };

      var footerContent;
      var onFooterClick;

      if (clearable) {
        footerContent = clearAllText;
        onFooterClick = boundClearAll;
      }

      if (multi && selectAllAction && (!isAllSelected || !clearable)) {
        footerContent = selectAllActionText;
        onFooterClick = boundSelectAll;
      }

      return react_1.default.createElement(List_1.default, {
        testId: menuContainerTestId,
        pinnedItems: pinnedItems,
        itemsJsx: itemsJsx,
        footerContent: footerContent,
        onFooterClick: onFooterClick,
        customMaxHeight: menuMaxHeight,
        customMinHeight: menuMinHeight,
        forceBottom: menuForceBottom,
        forceTop: menuForceTop,
        right: right,
        container: menuContainer,
        minWidth: menuMinWidth,
        maxWidth: menuMaxWidth,
        focused: focused,
        small: small
      });
    };
    /* istanbul ignore next */


    _this.setValue = function (value) {
      return _this.core.setValue(value);
    };

    return _this;
  }

  Object.defineProperty(Select.prototype, "isAllSelected", {
    get: function get() {
      var _a = convertProps(this.props),
          value = _a.value,
          options = _a.options;

      if (!value) {
        return false;
      }

      return options.reduce(function (result, option) {
        if (option.disabled) {
          return result;
        }

        var isOptionSelected = value.includes(option.value);
        return isOptionSelected && result;
      }, true);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Select.prototype, "showSelectAllPlaceholder", {
    get: function get() {
      var _a = this.props,
          selectAllPlaceholder = _a.selectAllPlaceholder,
          multi = _a.multi;
      var isAllSelected = this.isAllSelected;
      return multi && isAllSelected && selectAllPlaceholder;
    },
    enumerable: false,
    configurable: true
  });

  Select.prototype.componentDidMount = function () {
    handleEvent_1.handleEvent(this.props.onDidMount);
  };

  Select.prototype.render = function () {
    var _a;

    var _this = this;

    var _b = this,
        props = _b.props,
        menuRenderer = _b.menuRenderer,
        defaultValueRenderer = _b.valueRenderer;

    var classes = props.classes,
        multi = props.multi,
        valueRenderer = props.valueRenderer,
        secondary = props.secondary,
        placeholderTestId = props.placeholderTestId,
        small = props.small,
        onOpenReactSelect = props.onOpenReactSelect,
        onCloseReactSelect = props.onCloseReactSelect;
    var showSelectAllPlaceholder = this.showSelectAllPlaceholder;

    var _c = convertProps(props),
        placeholder = _c.placeholder,
        convertedProps = __rest(_c, ["placeholder"]);

    var placeholderJsx = react_1.default.createElement(Text_1.default, {
      testId: placeholderTestId,
      secondary: !secondary,
      mode: secondary ? 'small' : 'control'
    }, placeholder);
    return react_1.default.createElement("div", __assign({}, baseProps_1.default(props)), react_1.default.createElement(react_select_1.default, __assign({
      ref: function ref(component) {
        _this.core = component;
      },
      clearable: false,
      searchable: false,
      removeSelected: false,
      closeOnSelect: !multi,
      backspaceToRemoveMessage: "",
      placeholder: placeholder ? placeholderJsx : ''
    }, convertedProps, {
      menuRenderer: menuRenderer,
      valueRenderer: valueRenderer || defaultValueRenderer,
      arrowRenderer: arrowRenderer,
      className: classnames_1.default(classes.select, (_a = {}, _a[classes.smallSelect] = small, _a[classes.disableDelimiter] = showSelectAllPlaceholder, _a), modsClassName_1.modsClassName(props, 'inline', 'link', 'secondary'), mobileStylesHelper_1.createMobileClasses(props)),
      onOpen: onOpenReactSelect,
      onClose: onCloseReactSelect
    })));
  };

  Select = __decorate([withResponsive_1.withResponsive, withDefaultValue_1.withDefaultValue, inputable_1.inputable, withStyles_1.withStyles(ReactSelect_styles_1.default)], Select);
  return Select;
}(react_1.default.Component);

exports.default = Select;

function arrowRenderer(_a) {
  var isOpen = _a.isOpen;
  return react_1.default.createElement(Icon_1.default, {
    icon: drop_down_small_svg_1.default,
    upsidedown: isOpen
  });
}

exports.arrowRenderer = arrowRenderer;
/**
 * Адаптируем наше старое API к API react-select
 *
 * @todo Избавиться от адаптации и перейти на API react-select
 * @param {Props} props старое API
 * @returns {ReactSelectProps<string>} API react-select
 */

function convertProps(props) {
  var _a = props.onChange,
      _onChange = _a === void 0 ? baseProps_1.noop : _a,
      options = props.options,
      restProps = __rest(props, ["onChange", "options"]);

  return __assign(__assign({}, restProps), {
    options: normalizeOptions(options),
    onChange: function onChange(option) {
      _onChange(convertOptionsToValue(option));
    }
  });
}

exports.convertProps = convertProps;

function convertOptionsToValue(options) {
  if (!options) {
    return null;
  }

  return Array.isArray(options) ? options.map(convertOptionsToValue) : options.value;
}

exports.convertOptionsToValue = convertOptionsToValue;
/**
 * Преобразуем опции из старого формата к формату react-select
 *
 * @todo Избавиться от адаптации и перейти на API react-select
 * @param {Array<Option<string> | OptionData | string>} options
 * @returns {Options<string>}
 */

function normalizeOptions(options) {
  if (options === void 0) {
    options = [];
  }

  return options.map(function (option) {
    if (typeof option === 'string') {
      return {
        label: option,
        value: option
      };
    }

    var _a = option,
        text = _a.text,
        restOption = __rest(_a, ["text"]);

    return __assign({
      label: text,
      disabled: option.hr || option.disabled || option.unselectable
    }, restOption);
  });
}

exports.normalizeOptions = normalizeOptions;
/**
 * Выбирает все возможные варианты
 */

function selectAll(_a) {
  var setValue = _a.setValue,
      options = _a.options;
  setValue(options.options.filter(function (option) {
    if (!option.disabled) {
      return true;
    }

    return options.valueArray.includes(option);
  }));
}

exports.selectAll = selectAll;
/**
 * Очищает выделение
 */

function clearAll(_a) {
  var setValue = _a.setValue,
      props = _a.props,
      options = _a.options;
  var multi = props.multi;
  var valueArray = options.valueArray.filter(function (option) {
    return option.disabled;
  });

  if (multi) {
    setValue(valueArray);
    return;
  }

  if (!valueArray.length) {
    setValue(null);
  }
}

exports.clearAll = clearAll;